import axios from 'axios'

export const pingK8 = () => {
    return axios({
        method: `HEAD`,
        url: process.env.VUE_APP_BASE_API
    })
}
